export default __webpack_public_path__ + "static/digital-iden-f68e454910ecfb9c45f367bfcd7d137d.png";